/**
 * @generated SignedSource<<7cb8cfe86cf0a9b05febabce02de8235>>
 * @relayHash e6bef3774c4ca088f97d84dbcbbfe0e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d04cb14ca75f68e592cd783427fad2ea499b4cd59ff93b6a52b8afad8ef79247

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type list_RuleList_Query$variables = {
  cloudId: string;
  first: number;
  projectKey: string;
};
export type list_RuleList_Query$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly conditionalFormattingRules: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly expression: {
              readonly fieldId?: string;
            };
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"ruleItem_businessConditionalFormattingSidebar">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly key: string;
    };
  };
};
export type list_RuleList_Query = {
  response: list_RuleList_Query$data;
  variables: list_RuleList_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "list_RuleList_Query",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": (v5/*: any*/),
                    "concreteType": "JiraFormattingRuleConnection",
                    "kind": "LinkedField",
                    "name": "conditionalFormattingRules",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "expression",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "JiraFormattingMultipleValueOperand"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "JiraFormattingSingleValueOperand"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "JiraFormattingNoValueOperand"
                                  }
                                ]
                              },
                              {
                                "kind": "FragmentSpread",
                                "name": "ruleItem_businessConditionalFormattingSidebar"
                              }
                            ]
                          }
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "list_RuleList_Query",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": (v5/*: any*/),
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFormattingRuleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "expression",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": "multipleValueOperator",
                                    "kind": "ScalarField",
                                    "name": "operator"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "values"
                                  }
                                ],
                                "type": "JiraFormattingMultipleValueOperand"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": "singleValueOperator",
                                    "kind": "ScalarField",
                                    "name": "operator"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ],
                                "type": "JiraFormattingSingleValueOperand"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": "noValueOperator",
                                    "kind": "ScalarField",
                                    "name": "operator"
                                  }
                                ],
                                "type": "JiraFormattingNoValueOperand"
                              }
                            ]
                          },
                          {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "formattingColor",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "colorKey"
                              },
                              (v6/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "formattingArea"
                          }
                        ]
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d04cb14ca75f68e592cd783427fad2ea499b4cd59ff93b6a52b8afad8ef79247",
    "metadata": {},
    "name": "list_RuleList_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "131db143e9b223ae228d0bd1627900eb";

export default node;
